/* eslint-disable react/require-default-props,react/default-props-match-prop-types,react/destructuring-assignment,react/no-array-index-key */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export class CourseNavigationLinksPlaceholder extends PureComponent {
  static propTypes = {
    numItems: PropTypes.number.isRequired,
  };

  static defaultProps = {
    numItems: 1,
  };

  render() {
    const items = new Array(this.props.numItems);
    items.fill(null);

    return (
      <div className="section placeholder">
        <ul className="class-list">
          {items.map((value, index) => (
            <li key={index} className="item" />
          ))}
        </ul>
      </div>
    );
  }
}
